import axiosInstance from "api/axiosInstance";
import API from "api/endpoints";

const PerformanceReviewService = {
  // Fetch employees by department
  getDirectReports: async (supervisorId) => {
    return await axiosInstance.get(API.employee.directReports(supervisorId));
  },

  // Get performance reviews for employee - USING CORRECT ENDPOINT
  async getPerformanceReviews(employeeId) {
    const res = await axiosInstance.get(API.performanceReview.getPerformanceReviews(employeeId));
    return res.data;
  },

  // Get skills by employee
  async getSkillsByEmployee(employeeId) {
    const res = await axiosInstance.get(API.skills.getSkillsByEmployee(employeeId));
    return res.data;
  },

  // Get available skills
  async getAvailableSkills(departmentId) {
    const res = await axiosInstance.get(API.skills.getListByDept(departmentId));
    return res.data;
  },

  // Add skills
  async addSkills(payload) {
    const res = await axiosInstance.post(API.skills.addList, payload);
    return res.data;
  },

  async submitPerformanceReview(payload) {
    const res = await axiosInstance.post(API.performanceReview.createPerformanceReview, payload);
    return res.data;
  },

  async getPreviousReview(employeeId) {
    const res = await axiosInstance.get(API.performanceReview.getPreviousReview(employeeId));
    return res.data;
  },
};

export default PerformanceReviewService;
